var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "totals-statistics mt-1 mb-2" }, [
    _c("div", { staticClass: "d-flex align-items-center col" }, [
      _c("span", { staticClass: "statistics-heading" }, [
        _vm._v(
          "\n      Statistics for " + _vm._s(_vm.meta.total) + " jobs\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex align-items-center col justify-content-start" },
      [
        _c("span", { staticClass: "statistics-heading total-hours" }, [
          _vm._v("\n      " + _vm._s(_vm.sums.total_hours) + "\n    ")
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex align-items-center col justify-content-center" },
      [
        _c("span", { staticClass: "statistics-heading total-amount" }, [
          _vm._v("\n      $" + _vm._s(_vm.sums.total_amount) + "\n    ")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6937d97a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6937d97a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/MoverTotalsStatistics.vue
// module id = null
// module chunks = 